<template>
  <div class="animated">
    <b-card header="사전예약 리스트 등록하기">
      <div class="p-3">
        <span>진행 중, 진행 예정 사전예약을 리스트에 노출할 수 있어요.</span>
        <br>
        <span>이미 리스트에 등록된 사전예약은 조회되지 않습니다.
        </span>
        <b-table hover striped bordered small fixed responsive="sm" :items="this.preeceedingOrExpectedPregListWithNoShowTime" :fields="v2fields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다." class="mt-3">
          <template slot="market" slot-scope="data">
            {{data.item.marketInfo.marketType}}
          </template>
          <template slot="startTime" slot-scope="data">
            {{data.item.startTime ? data.item.startTime.format('YY.MM.DD HH:mm') : '미등록'}}
          </template>
          <template slot="type" slot-scope="data">
            {{getTypeName(data.item.type, this.codes)}}
          </template>
          <template slot="endTime" slot-scope="data">
            {{data.item.endTime ? data.item.endTime.format('YY.MM.DD HH:mm') : '미등록'}}
          </template>
          <template slot="management" slot-scope="data">
            <b-link :to="{name: 'showListForm', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}, query: {market: data.item.marketInfo.marketType}}" class="mr-2">[등록]</b-link>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="this.preeceedingOrExpectedPregListWithNoShowTime.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </div>
    </b-card>
  </div>
</template>
<script>
import { PREECEEDING, EXPECTED } from '@/constants'
import {MODULE_NAME as PREG_MODULE, FETCH_PREGS, FETCH_CODES} from '@/store/preg/actions.type'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { $getTypeName, $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
export default {
  data () {
    return {
      v2fields: [
        {key: 'appInfo.appName', label: '게임명', class: 'align-middle text-center'},
        {key: 'marketInfo.marketType', label: '마켓', class: 'align-middle text-center'},
        {key: 'name', label: '제목', class: 'align-middle text-center'},
        {key: 'type', label: '종류', class: 'align-middle text-center'},
        {key: 'startTime', label: '시작', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
        {key: 'endTime', label: '종료', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
        {key: 'management', label: '리스트 관리', class: 'align-middle text-center'}
      ],
      fields: [
        {key: 'pregMaster.id', label: 'id', class: 'align-middle text-center', thStyle: {width: '50px'}},
        {key: 'pregMaster.appInfo.appName', label: '게임명', class: 'align-middle text-center'},
        {key: 'marketInfo.marketType', label: '마켓', class: 'align-middle text-center'},
        {key: 'pregMaster.name', label: '제목', class: 'align-middle text-center'},
        {key: 'type', label: '종류', class: 'align-middle text-center'},
        {key: 'startTime', label: '시작', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
        {key: 'endTime', label: '종료', class: 'align-middle text-center', sortable: true, thStyle: {width: '125px'}},
        {key: 'management', label: '사전예약 카드 관리', class: 'align-middle text-center'}
      ],
      currentPage: 1,
      perPage: 5,

      gapCurrentPage: 1,
      gapPerPage: 5,

      getTypeName: $getTypeName,

      gapPregList: []
    }
  },
  mounted () {
    this.$store.dispatch(PREG_MODULE + FETCH_CODES)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(PREG_MODULE + FETCH_PREGS)
      .catch($showModalWithErrorMsg.bind(this))
  },
  computed: {
    preeceedingOrExpectedPregListWithNoShowTime () {
      return this.pregListByEachMarket.filter(item => {
        return (item.status.value === PREECEEDING || item.status.value === EXPECTED) &&
          ((item.marketInfo !== undefined ? item.marketInfo.startShowTime === null : false) && (item.marketInfo !== undefined ? item.marketInfo.endShowTime === null : false))
      })
    },
    ...mapGetters('preg', [
      'pregListByEachMarket'
    ]),
    ...mapState('preg', [
      'codes'
    ])
  },
  methods: {
    ...mapMutations('ui', [SHOW_MODAL]),
    convertTempType(type) {
      return type==='new'?'newGame':type==='update'?'updateGame':type
    }
  }
}
</script>
